/*Below comment for Sonarlint*/
/*global closeThis, SampleOrder */

jQuery(function () {
//review modal
if (!$('#reviewDropdown').hasClass('hidden')) {
    const reviewModal = document.getElementById('modal');
    const openModalBtn = document.querySelector('.reviewModalHeadline a');
    const closeReviewModal = document.getElementById('closeModalBtn');
    if (openModalBtn) {
        openModalBtn.addEventListener('click', () => {
            reviewModal.style.display = 'flex';
            setTimeout(() => {
                reviewModal.style.opacity = '1';
                document.querySelector('.modal-content').style.transform = 'translateY(0)';
            }, 10);
        });
    }


    if (closeReviewModal) {
        closeReviewModal.addEventListener('click', () => {
            reviewModal.style.opacity = '0';
            document.querySelector('.modal-content ').style.transform = 'translateY(-50px)';
            setTimeout(() => {
                reviewModal.style.display = 'none';
            }, 500);
        });
    }

    window.addEventListener('click', (e) => {
        if (e.target === reviewModal) {
            closeReviewModal.click();
        }
    });
}


//detail components scripts
//hide review dropdown if all stars are empty 
$(window).on("load", function () {
    if ($("#reviewDropdown, .accordationReview").length) {
        setTimeout(function () {
            if ($(".accordationReview .pr-rating-stars").length) {
                $("#reviewDropdown .accordationReview .pr-star-v4-0-filled").each(function () {
                    var totoalZeroReview = $("#reviewDropdown").find(".accordationReview .pr-star-v4-0-filled");
                    if (totoalZeroReview.length === 5) {
                        $("#reviewDropdown").addClass("hidden");
                    };
                })
            };
        }, 500);
    }
});
//H1 Tag change in review section
$(window).on("load", function () {
    setTimeout(function () {
        $(".pr-headline").replaceWith($('<h3 class="pr-headline">' + $(".pr-headline").html() + '</h3>'));
        $(".pr-rd-review-total").replaceWith($('<h3 class="pr-rd-review-total">' + $(".pr-rd-review-total").html() + '</h3>'));
        $(".pr-review-snapshot-block-headline").replaceWith($('<h3 class="pr-review-snapshot-block-headline">' + $(".pr-review-snapshot-block-headline").html() + '</h3>'));
        $(".pr-review-snapshot-snippets-headline").replaceWith($('<h3 class="pr-review-snapshot-snippets-headline">' + $(".pr-review-snapshot-snippets-headline").html() + '</h3>'));
    },  1000);
});

//GA4 on page load
$(document).ready(function () {
    var productId = $("#product-id").data("product-id") || "default_id";
    var productName = $("#product-name").data("product-name").trim() || "default_name";

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "ga4_view_product",
        "ga4_data": {
            "single_item_id": productId,
            "single_item_name": productName
        }
    });
    $(".ga4-contact-cta").on("click", function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "ga4_contact_us_product_cta",
            "ga4_data": {
                "single_item_id": productId,
                "single_item_name": productName
            }
        });
    });
});

    $(document).on('click', '.mfp-close, .btn-video-play', function () {
    var $usageAccordionTitle = $('[aria-controls="Usage-content"]');
    var $usageAccordionContent = $('#Usage-content');

    if ($usageAccordionTitle.length && $usageAccordionContent.length) {
        $usageAccordionTitle.attr('aria-expanded', 'true');
        $usageAccordionTitle.addClass('open');
        $usageAccordionContent.slideDown(300);
    }
});
// onclick review link scroll review comment section
    var reviewDropdownScroll = function (event) {
        $('#deskReviewMainSection .pr-snippet-read-and-write a, #deskReviewMainSection .pr-snippet-review-count, #mobReviewMainSection .pr-snippet-read-and-write a, #mobReviewMainSection .pr-snippet-review-count'
        )
            .off('click.reviewDropdownScroll')
            .on('click.reviewDropdownScroll', function (e) {
                e.preventDefault();
                var $reviewDropdown = $('#reviewDropdown');

                if (!$reviewDropdown.length) return;

                if (!$reviewDropdown.hasClass('accordion-expanded')) {
                    $reviewDropdown.trigger('click');
                }

                setTimeout(function () {
                    $('html, body').stop().animate({
                        scrollTop: $reviewDropdown.offset().top - 20
                    }, 400);
                }, 200);
            });
    }
jQuery(function () {
    // H1 headline append to desk or mob
    if ($('.deskHeadline').length) {
        $('.mainHeadlineSection').appendTo('.deskHeadline').css('display', 'block');
    } else {
        $('.mainHeadlineSection').remove('.deskHeadline');
    }
    if (window.matchMedia('(max-width: 1118px)').matches) {
        if ($('.mobHeadline').length) {
            $('.mainHeadlineSection').appendTo('.mobHeadline').css('display', 'block');
        } else {
            $('.mainHeadlineSection').appendTo('.deskHeadline').css('display', 'block');
        }
    }
    // ProductVdo append 
    if ($('.deskProductVdo').length) {
        $('.ProductVdo').appendTo('.deskProductVdo').css('display', 'block');
    } else {
        $('.ProductVdo').remove('.deskProductVdo');
    }
    if (window.matchMedia('(max-width: 1118px)').matches) {
        if ($('.mobProductVdo').length) {
            $('.ProductVdo').appendTo('.mobProductVdo').css('display', 'block');
        } else {
            $('.ProductVdo').appendTo('.deskProductVdo').css('display', 'block');
        }
    }
    // Review main section append 
    if ($('.deskReviewMainSection').length) {
        $('.reviewMainSection').appendTo('.deskReviewMainSection').css('display', 'block');
    } else {
        $('.reviewMainSection').remove('.deskReviewMainSection');
    }
    if (window.matchMedia('(max-width: 1118px)').matches) {
        if ($('.mobReviewMainSection').length) {
            $('.reviewMainSection').appendTo('.mobReviewMainSection').css('display', 'block');
        } else {
            $('.reviewMainSection').appendTo('.deskReviewMainSection').css('display', 'block');
        }
    }
})
// ProductVdo and reviewsection append resize
$(window).resize(function () {
    //less then 1023 cover mob and ipad
    if ($(window).width() <= 1118) {
        $('.mainHeadlineSection').appendTo('.mobHeadline').css('display', 'block');
        $('.ProductVdo').appendTo('.mobProductVdo').css('display', 'block');
        $('.reviewMainSection').appendTo('.mobReviewMainSection').css('display', 'block');
    } else {
        $('.mainHeadlineSection').appendTo('.deskHeadline').css('display', 'block');
        $('.ProductVdo').appendTo('.deskProductVdo').css('display', 'block');
        $('.reviewMainSection').appendTo('.deskReviewMainSection').css('display', 'block');
    }
})
// ProductBenefit append and product headline append
var ProductBenefitApnd = function (event) {
    if ($('.deskProductBenefit').length) {
        $('.ProductBenefit').appendTo('.deskProductBenefit').css('display', 'block');
        if ($('.ProductBenefit').is(':visible') || $('.ProductBenefit').length) {

            $('.pr-snippet-read-and-write').css('opacity', '1');
            reviewDropdownScroll(event);
        } else { }
    } else {
        $('.ProductBenefit').remove('.deskProductBenefit');
    }
    if (window.matchMedia('(max-width: 1118px)').matches) {
        if ($('.mobProductBenefit').length) {
            $('.ProductBenefit').appendTo('.mobProductBenefit').css('display', 'block');
            if ($('.ProductBenefit').is(':visible')) {
                $('.pr-snippet-read-and-write').css('opacity', '1');
                reviewDropdownScroll(event);
            } else {
                $('.pr-snippet-read-and-write').css('opacity', '0');
            }
        } else {
            $('.ProductBenefit').remove('.deskProductBenefit');
        }
    }
}
// ProductBenefit append resize
$(window).resize(function () {
    //less then 1023 cover mob and ipad
    if ($(window).width() <= 1118) {
        $('.ProductBenefit').appendTo('.mobProductBenefit').css('display', 'block');
        if ($('.ProductBenefit').is(':visible')) {
            //onclick review show review dropdown  
            $('.pr-snippet-read-and-write').css('opacity', '1');
            reviewDropdownScroll();
        } else {
            $('.pr-snippet-read-and-write').css('opacity', '0');
        }
    } else {
        $('.ProductBenefit').appendTo('.deskProductBenefit').css('display', 'block');
    }
})
$(window).on("load", function () {
    setTimeout(function () {
        ProductBenefitApnd();
    }, 200);
});
$(window).resize(function () {
    ProductBenefitApnd();
});
$('.productBoxWrapper').on('click', function () {
    setTimeout(function () {
        ProductBenefitApnd();
    }, 400);
})
jQuery(function () {
    setTimeout(function () {
        ProductBenefitApnd();
    }, 400);
    //Product detail Redesign Pack Size menu
    $('.viewport').after('<div class="packSize" style="overflow: hidden;"></div><div style="top:0;bottom:0;right: 0;left:0;pointer-events:none;z-index: 1043;top: 0;height: 100%;" class="mainT"><div style="position: absolute;width: 100%;left: 0;" class="backdropWrapper"></div></div>');
    //Product detail Redesign Functionality Pack size appended HTML 
    var packSizeMenu = '<div class="packSizeWrapper" id="packSizeWrapper"><div class="packSizeInfo"><div class="packSizeHeader"><div class="closeThis" id="closeThis"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx = "20" cy = "20" r = "20" fill = "#003A81" /><rect width="16" height="16" transform="translate(12 12)" fill="white" fill-opacity="0.01"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8203 14.1008L14.8779 14.1506L20 19.2725L25.1221 14.1506C25.3229 13.9498 25.6485 13.9498 25.8494 14.1506C26.032 14.3332 26.0485 14.6189 25.8992 14.8203L25.8494 14.8779L20.7275 20L25.8494 25.1221C26.0502 25.3229 26.0502 25.6485 25.8494 25.8494C25.6668 26.032 25.3811 26.0485 25.1797 25.8992L25.1221 25.8494L20 20.7275L14.8779 25.8494C14.6771 26.0502 14.3515 26.0502 14.1506 25.8494C13.968 25.6668 13.9514 25.3811 14.1008 25.1797L14.1506 25.1221L19.2725 20L14.1506 14.8779C13.9498 14.6771 13.9498 14.3515 14.1506 14.1506C14.3129 13.9883 14.5567 13.9572 14.7503 14.0572L14.8203 14.1008Z" fill="white"/></svg></div></div><div class="row" id="checkInfo"><div class="row redesignMarginB" id="innerHtmlPackSize"></div>';
    if ($('.backdropWrapper').length) {
        $('.backdropWrapper').append(packSizeMenu);
        $('#packSizeWrapper').css('display', 'none');
    }
    //Pack size slide right window onclick close
    $(".clickshowinfo").on("click keypress", function (event) {
        if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
            $('.mainT').css('position', 'fixed');
            $('.menu-wrapper.sticky').css('z-index', '999');
            $('#packSizeWrapper').css('display', 'block');
            $('#packSizeHtml').css('display', 'block');
            $(".backdropWrapper").css({
                height: "100%"
            });
            if ($('.packSizeWrapper').length) {
                var replaceHtml = document.getElementById("packSizeHtml").innerHTML;
                document.getElementById("innerHtmlPackSize").innerHTML = replaceHtml;
            } else {
                return false;
            }
            if (window.matchMedia('(max-width: 767px)').matches) {
                $(".packSizeWrapper").animate({
                    top: "auto",
                    bottom: "0"
                }, 200);
                $(".packSizeInfo").animate({
                    top: "auto",
                    bottom: "0"
                }, 200);
            } else if (window.matchMedia('(max-width: 1024px)').matches) {
                $(".packSizeWrapper").animate({
                    width: "45%"
                }, 200);
                $(".packSizeInfo").animate({
                    width: "100%"
                }, 200);
            } else {
                $(".packSizeWrapper").animate({
                    width: "538px"
                }, 200);
                $(".packSizeInfo").animate({
                    width: "100%"
                }, 200);
            }
            $(".backdropWrapper").css('pointer-events', 'all');
            $('.packSize').addClass('packSizeBackdrop');
            $('html').css('overflow', 'hidden');
        }
    });

    //Pack size slide right window outside close
    var backdropWrapper = document.getElementsByClassName("backdropWrapper");
    var closeFunction = function (e) {
        var containerT = document.getElementById('packSizeWrapper');
        var closeThiscloseThis = document.getElementById('closeThis');
        var clickshowinfo = document.getElementById(clickshowinfo);
        if ($('.packSizeWrapper').length) {
            if (!containerT.contains(e.target) || closeThis.contains(e.target)) {
                $('#packSizeHtml').css('display:none');
                $('html').css('overflow', 'auto');
                $('#packSizeHtml').css('display', 'none');
                $('.menu-wrapper.sticky').css('z-index', '10000');
                if (window.matchMedia('(max-width: 767px)').matches) {
                    $(".packSizeWrapper").animate({
                        top: "auto",
                        bottom: "-100%"
                    }, 200);
                    $(".packSizeInfo").animate({
                        top: "auto",
                        bottom: "-100%"
                    }, 200);
                    $('#packSizeHtml').css('display:none');
                } else {
                    $(".packSizeWrapper").animate({
                        width: "0%"
                    }, 200);
                    $(".packSizeInfo").animate({
                        width: "0%"
                    }, 200);
                }
                $(".backdropWrapper").css('pointer-events', 'none');
                $('.packSize').removeClass('packSizeBackdrop');
            }
        }
    };
    for (var i = 0; i < backdropWrapper.length; i++) {
        backdropWrapper[i].addEventListener('click', closeFunction, false);
    }
    $(".closeThis").click(function (e) {
        if (e.type === "click" || (e.type === "keypress" && e.key === "Enter")) {
            closeFunction(e);
        }
    });
});
/*..GA sample btn..*/
$('.samplebtn').click(function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "ga4_sample_form_cta",
        "ga4_data": {
            "link_text": "Sample request",
        }
    });
});

});

$(document).ready(function () {
    const checkStars = setInterval(function () {
        const $stars = $(".pr-snippet-stars");
        if ($stars.length && !$stars.attr("tabindex")) {
            $stars.attr("tabindex", "0");
            clearInterval(checkStars);
        }
    }, 500);
});